import React from "react";
import { Card } from 'primereact/card';
import {
    ListBulletIcon,
    AcademicCapIcon,
    ArchiveBoxIcon,
    VideoCameraIcon,
    CalendarDaysIcon,
    Cog6ToothIcon,
    BuildingLibraryIcon
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

// Reusable Setting Card component
const SettingCard = ({ icon: Icon, label, to }: { icon: React.ComponentType<React.SVGProps<SVGSVGElement>>, label: string, to: string }) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate(to);
    };

    return (
        <div className="card lg:w-auto w-full" onClick={handleCardClick}>
            <Card className="cursor-pointer">
                <div className="flex items-center">
                    <Icon className={`w-6 h-6 text-gray-700`} />
                    <span className="ml-2 text-primary font-bold" style={{ color: `` }}>{label}</span>
                </div>
            </Card>
        </div>
    );
};

const SettingPage: React.FC = () => {
    const settingsData = [
        { icon: ListBulletIcon, label: "Sub Cast", to: "/admin/subcast" },
        { icon: ListBulletIcon, label: "Surnames", to: "/admin/surnames" },
        { icon: BuildingLibraryIcon, label: "Government Departments", to: "/admin/govtdepartment" },
        /// { icon: ListBulletIcon, label: "Registration Document", to: "/admin/registrationdoc" },
        /// { icon: BuildingLibraryIcon, label: "Business Type", to: "/admin/businesstype" },
        // { icon: BuildingLibraryIcon, label: "Business Category", to: "/admin/businesscategory" },
        /// { icon: BuildingOfficeIcon, label: "Marketing Yards", to: "/admin/marketingyards" },/
        /// { icon: BuildingLibraryIcon, label: "Registration Type", to: "/admin/registrationtype" },
        // { icon: BuildingLibraryIcon, label: "Product Type", to: "/admin/producttype" },
        /// { icon: BuildingLibraryIcon, label: "Business Member Tag", to: "/admin/businessmemtag" },
        { icon: ArchiveBoxIcon, label: "Advertisement Package", to: "/admin/advertisementpackage" },
        { icon: ListBulletIcon, label: "Bazar Bhav", to: "/admin/bazarbhav" },
        { icon: AcademicCapIcon, label: "Education Rules", to: "/admin/educationrule" },
        { icon: ListBulletIcon, label: "Privacy Policy", to: "/admin/privacypolicy" },
        { icon: ListBulletIcon, label: "About us", to: "/admin/aboutus" },
        { icon: ListBulletIcon, label: "Terms and Conditions", to: "/admin/termsandcondition" },
        { icon: ListBulletIcon, label: "Contact us", to: "/admin/contactus" },
        { icon: VideoCameraIcon, label: "Live Video", to: "/admin/livevideo" },
        { icon: VideoCameraIcon, label: "Page Videos", to: "/admin/pagevideo" },
        { icon: CalendarDaysIcon, label: "Events", to: "/admin/event" },
        { icon: ListBulletIcon, label: "Home Content", to: "/admin/homecontent" },
        { icon: Cog6ToothIcon, label: "Application Settings", to: "/admin/applicationsettings" }
    ];

    return (
        <div className="dashboard-margin flex gap-2 flex-wrap">
            {settingsData.map((setting, index) => (
                <SettingCard
                    key={index}
                    icon={setting.icon}
                    label={setting.label}
                    to={setting.to} // Passing the `to` prop to the SettingCard
                />
            ))}
        </div>
    );
};

export default SettingPage;
